import { FC, ReactNode } from 'react';
import { PanelRightOpen, PanelRightClose } from 'lucide-react';
import { cn } from '@new/lib';

interface CourseHearingLayoutProps {
  header: ReactNode;
  videoArea: ReactNode;
  controls: ReactNode;
  sidePanel?: ReactNode;
  isSidePanelOpen?: boolean;
  onToggleSidePanel?: () => void;
  isInstructor?: boolean;
  isPiPActive?: boolean;
}

export const CourseHearingLayout: FC<CourseHearingLayoutProps> = ({
  header,
  videoArea,
  controls,
  sidePanel,
  isSidePanelOpen = true,
  onToggleSidePanel,
  isInstructor = false,
  isPiPActive = false,
}) => {
  return (
    <div
      className="fixed inset-0 z-50 bg-[#FAFDFF]! flex flex-col lg:flex-row w-full h-full overflow-y-auto lg:overflow-hidden"
      style={isPiPActive ? { visibility: 'hidden' } : undefined}
    >
      <div
        className={cn(
          'flex flex-col overflow-hidden',
          isSidePanelOpen ? 'lg:w-[60%] w-full' : 'w-full',
          'lg:h-full'
        )}
      >
        {header}

        {videoArea}

        <div className="bg-white">
          <div className="flex items-center justify-center relative">
            {controls}
            {isInstructor && onToggleSidePanel && (
              <button
                onClick={onToggleSidePanel}
                className="absolute right-4 p-2 rounded-lg text-neutral-500 hover:bg-neutral-100 hover:text-neutral-700 transition-colors cursor-pointer lg:flex hidden"
                aria-label={isSidePanelOpen ? 'Close side panel' : 'Open side panel'}
              >
                {isSidePanelOpen ? <PanelRightClose size={20} /> : <PanelRightOpen size={20} />}
              </button>
            )}
          </div>
        </div>
      </div>

      {isSidePanelOpen && sidePanel && (
        <div className={cn('flex min-h-0', 'w-full lg:w-[40%]', 'flex-1 lg:h-full')}>
          {sidePanel}
        </div>
      )}
    </div>
  );
};
